var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.029 273.977L208.586 301.248C212.969 292.826 215.258 283.471 215.258 273.977C215.258 264.482 212.969 255.128 208.586 246.706L154.029 273.977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M491.46 246.706C487.076 255.128 484.787 264.482 484.787 273.977C484.787 283.471 487.076 292.826 491.46 301.248L546.016 273.977L491.46 246.706Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 641.667C109.689 609.598 102.137 574.798 102.084 539.584H180.834C191.366 539.584 201.545 535.785 209.502 528.884C217.458 521.983 222.658 512.444 224.146 502.017L233.334 437.5L291.536 414.167C293.41 413.418 295.107 412.288 296.522 410.849C297.936 409.41 299.036 407.693 299.753 405.807C300.47 403.921 300.788 401.907 300.686 399.892C300.585 397.877 300.066 395.905 299.163 394.1L247.917 291.667C247.917 145.834 209.111 72.917 58.334 72.917",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.584 107.436C69.4173 156.771 138.542 267.765 14.584 422.363",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M575.766 641.667C590.313 609.598 597.864 574.798 597.918 539.584H519.168C508.635 539.584 498.457 535.785 490.5 528.884C482.544 521.983 477.344 512.444 475.855 502.017L466.668 437.5L408.466 414.167C406.592 413.418 404.894 412.288 403.48 410.849C402.066 409.41 400.965 407.693 400.248 405.807C399.531 403.921 399.214 401.907 399.315 399.892C399.417 397.877 399.936 395.905 400.838 394.1L452.084 291.667C452.084 145.834 490.891 72.917 641.668 72.917",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M510.418 107.436C630.541 156.771 561.46 267.765 685.418 422.436",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M375.07 77.7C365.031 67.7284 356.577 56.2792 350.001 43.75C343.426 56.2792 334.972 67.7284 324.933 77.7C315.122 87.4405 303.91 95.6591 291.668 102.083C316.585 115.153 336.931 135.5 350.001 160.417C363.071 135.5 383.418 115.153 408.335 102.083C396.093 95.6591 384.881 87.4405 375.07 77.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiLogo);
export default __webpack_public_path__ + "static/media/geminiLogo.96775c01e83c87adf1e7c48a90d9c3a2.svg";
export { ForwardRef as ReactComponent };